import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { AuthenticationService } from '../auth/authentication.service';
import { Router } from '@angular/router';
import * as dayjs from 'dayjs';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private localStorageService: LocalStorageService, private authenticationService: AuthenticationService, private router: Router) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (this.authenticationService.isLoggedOut()) {
      return throwError('Usuário deslogado!');
    }

    let tempReq: HttpRequest<any>;

    let token = this.localStorageService.getItem('token');

    if (token && this.authenticationService.currentUserValue.mustChangePassword) {
      this.authenticationService.mustChangePassword();
    }

    if (token && !request.headers.has('public')) {
      try {
        token = JSON.parse(token)
      } catch {

      }

      tempReq = request.clone({
        headers: request.headers.set('Authorization', `${token}`) //`Bearer ${token}`
      })

    } else {
      tempReq = request.clone({
        headers: request.headers.delete('public')
      })
    }
    if (!tempReq.headers.has('Content-Type')) {
      tempReq.headers.set('Content-Type', 'application/json');
    }

    return next.handle(tempReq)
  }
}
